module.exports = __webpack_public_path__ + "img/Villa_Borna_65.fe587e43.jpg";